<template>
	<div class="yj-nav">
		<div class="yj-nav-content">
			<!-- 欢迎登录空港嘉华企业差旅系统 -->
			<span>
				欢迎登录{{configData2.corpName}}差旅系统 
				
				<span style="margin-left: 10px;">当前企业:[<el-button type="text" style="cursor:initial">{{vipCorp.fullname}}</el-button>]</span>
				<el-button class="enter-etsms-admin" v-if="corpList.length>1" style="margin-left: 20px;" type="text" @click="qieHuanCorp()">切换企业</el-button>

			</span>
			<div>
				<!-- <el-button class="btn-old" @click="goOldEdition">返回旧版</el-button> -->
				<el-button class="enter-etsms-admin" v-if="empInfo.isAdmin==1" type="text" @click="enterEtsmsAdmin()">进入管理端</el-button>
			</div>
			
			
		</div>
		<!-- 切换企业 -->
		<el-dialog
			:title="title"
			:close-on-click-modal="false"
			:visible.sync="visible"
			:before-close="handleClose"
			style="text-align: left;"
			width="800px"
			>
			<div style="height: 400px;overflow-y: scroll;">	
				<div class="corp-item" v-for="(corpItem,corpIndex) in corpList" :key="'corpList_' + corpIndex">
					<div>
						<div class="corp-tap">企业</div>
						<div class="corp-name">
							{{ corpItem.shortname }}
						</div>
					</div>

					<div class="dept-item" v-for="(deptItem,deptIndex) in corpItem.deptList" :key="deptIndex" @click="chooseDeptItem(corpItem,deptItem)">
						<div>
							<div class="dept-tap">部门</div>
							<div class="dept-name">
								{{ deptItem.vipdeptName }}
							</div>
						</div>
						<div>
							<span 
								class= "iconfont yj-icon-zhwc_icon " 
								:class="{'has-choose':chooseDeptId == deptItem.deptId,'no-choose': chooseDeptId != deptItem.deptId}" 
							></span>
						
						</div>
							
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取消</el-button>
				<el-button type="primary" @click="confirm('ruleForm')" :loading="loading">保存</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>

	import loginMixin from "@/mixin/models/loginMixin.js"
	
	export default{
		data(){
			return {
				corpList:[],
				visible:false,
				title:"切换企业",
				chooseCorpId:"",
				chooseDeptId:"",
				userInfo:{},
				vipCorp:{},
				empInfo:{},
				configData2:{},

				loading:false,
			}
		},
		mixins:[loginMixin],

		watch:{
	
		},
		mounted(){
			this.getUserInfoConfig();

			this.chooseCorpId = this.empInfo.corpId;
			this.chooseDeptId = this.empInfo.deptId;
			this.getCorpList();



			this.$bus.$on('user-updated', this.getUserInfoConfig)
		},
		methods:{
			getUserInfoConfig(){
				this.userInfo = this.$common.getUserInfo() || {};
				this.empInfo = this.userInfo.empInfo || {} ;
				this.vipCorp = this.userInfo.vipCorp || {};
				this.configData2 = this.$common.getConfigData();
			},


			enterEtsmsAdmin(){
				var origin = window.location.origin;
				var path = '/admin/#/app/companyinfo';
				let routerUrl = origin + path;
				// 远程跳转
				window.open(routerUrl,"_blank");
				// let path = '/admin/#/app/companyinfo'
				// let routerUrl = this.$router.resolve({path:path})
				// // 远程跳转
				// window.open(routerUrl.href,"_blank");
					
			},
			// 跳转obt 老版本
			goOldEdition(){
				// 新版obt 2022，旧版 2017
				this.$common.localset("obt-version", "2017"); 
				
				// window.location.href="/obt-web/blocks/jump.html"
				window.location.replace("/obt-web/blocks/jump.html")
			},
			// 切换企业
			qieHuanCorp(){
				this.getCorpList(true);
			},
			getCorpList(bool){
				let obj = {};
				let queryUrl = 'user.getUserCorpList'
				this.$conn.getConn(queryUrl)(obj,(res)=>{

					this.corpList =  res.data || [];
					if(bool){
						this.visible = true;
					}

				},(err)=>{

					this.$message({
						type: 'error',
						message: err.tips
					})
				})
			},
			// 切换企业  确认
			confirm(){
				this.loading = true;
				let queryString = {
					"corpId": this.chooseCorpId,
					"deptId": this.chooseDeptId,
					refresh:1,
				};
				// 来源于loginMinxin.js   reLogin
				this.reLogin(queryString,()=>{
					this.$bus.$emit('user-updated',true)

					this.loading = false;
					this.visible = false;
				},(err)=>{
					this.loading = false;
				})
			},
			handleClose(){
				this.visible = false;
			},
			chooseDeptItem( corpItem,deptItem){

				this.chooseCorpId = corpItem.corpId;
				this.chooseDeptId = deptItem.deptId;
			}
			
		}
	}
</script>

<style scoped="scoped" lang="scss">
	.yj-nav{
		width: 100%;
		height:26px;
		background: #DDDFE3;
		font-size: 12px;
		.yj-nav-content{
			height: 100%;
			width: 1200px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin: 0 auto;
			.enter-etsms-admin{
				
			}
			.btn-old{
				padding: 4px 10px;
				border: 1px solid #E5EAF3;
				border-radius: 10px;
				color: #637697;
				font-size: 12px;
			}
		}
	}

	.corp-item{
		min-height: 40px;
		padding: 8px 0px;
		box-sizing: border-box;
		padding-left: 60px;
		border-top: 1px solid #E2E2E2;
	}
	.dept-item{
		min-height: 37px;
		opacity: 1;
		padding: 8px 0px;
		gap: 2px;
		box-sizing: border-box;
		padding-left: 30px;
		padding-right: 30px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		// border-top: 1px solid #E2E2E2;
		cursor: pointer;

	}
	

	.corp-tap{
		display: inline-block;
			padding: 2px 4px;
			height: 18px;
			border-radius: 2px;
			/* 蓝色-主色 */
			background: #1B8CFF;
			color: #fff;
			font-size: 12px;
			font-weight: normal;
			line-height: 12px;
		}
		.dept-tap{
			display: inline-block;
			height: 16px;
			border-radius: 2px;
			padding: 2px;
			/* 白色 */
			background: #fff;
			box-sizing: border-box;
			/* 灰色3-禁用文字&边框 */
			border: 1px solid #E2E2E2;
			font-size: 12px;
			font-weight: normal;
			line-height: 12px;
			letter-spacing: 0px;

			font-variation-settings: "opsz" auto;
			/* 灰色5-辅助文字 */
			color: #9C9C9C;
		}


		.corp-name{
			display: inline-block;
			min-height: 48rpx;
			opacity: 1;

			/* 16三级 */
			font-family: PingFang SC;
			font-size: 16px;
			font-weight: normal;
			line-height: 24px;
			color:#1B8CFF;
			margin-left: 3px;
		}



		.dept-name{
			display: inline-block;
			min-height: 21px;
			opacity: 1;

			/* 14四级 */
			font-family: PingFang SC;
			font-size: 14px;
			font-weight: normal;
			line-height: 21px;
			letter-spacing: 0px;

			font-variation-settings: "opsz" auto;
			z-index: 1;
			/* 大兴机场 PKX */
			color: #222;
			margin-left: 4px;

		}

		.no-choose{
			font-size: 18px;
			color: #E2E2E2;
		}
		.has-choose{
			font-size: 18px;
			color: #1B8CFF;
		}
</style>
